export const ErrorMessage = ({ message }) => (
  <div className='text-center'>
    <p className='text-[--error] text-lg'>{message}</p>
  </div>
)
